import type { ReactNode } from 'react';
import { Card, CardContent } from '@/components/Card/card';
import { FillScreen, VStack } from '@/components/Layout';
import { Text } from '@/components/Typography/Text';
import { cn } from '@/lib/cn';
type ErrorScreenProps = {
  icon?: ReactNode;
  title: ReactNode;
  description: ReactNode;
  children?: ReactNode;
  className?: string;
  role?: string;
};
export function ErrorScreen({
  icon,
  title,
  description,
  children,
  className,
  role
}: ErrorScreenProps) {
  return <FillScreen className="flex items-center justify-center">
      <Card className={cn('max-w-dialog-lg', className)} role={role}>
        <CardContent className="px-14 py-14">
          <VStack className="items-center gap-6">
            {icon}
            <VStack className="items-center gap-3">
              <Text variant="h3" as="h1" className="text-neutral-on-fill text-center">
                {title}
              </Text>
              <Text variant="p" className="text-center text-neutral-muted-on-fill whitespace-pre-wrap">
                {description}
              </Text>
            </VStack>
            {children && <VStack className="items-center gap-3">{children}</VStack>}
          </VStack>
        </CardContent>
      </Card>
    </FillScreen>;
}